import React, { useState } from "react";

function FAQs() {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: "What is ShopEase?",
            answer:
                "ShopEase is an online marketplace that offers a wide variety of products including fashion, electronics, and home essentials, with a focus on quality and affordability.",
        },
        {
            question: "How can I track my order?",
            answer:
                "After placing your order, you will receive a tracking ID via email. You can use this ID on our website under 'Track Order' to check real-time updates.",
        },
        {
            question: "What is the return policy?",
            answer:
                "We offer a 7-day easy return policy. If you’re not satisfied with your purchase, you can request a return or replacement within 7 days of delivery.",
        },
        {
            question: "Do you offer international shipping?",
            answer:
                "Yes, we ship to multiple countries. Shipping charges and delivery times may vary based on the destination.",
        },
        {
            question: "How can I contact customer support?",
            answer:
                "You can reach our support team via email at support@shopease.com or by calling +91-9876543210. Our team is available 24/7.",
        },
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow">
            <h1 className="text-3xl font-bold mb-6">Frequently Asked Questions</h1>
            {faqs.map((faq, index) => (
                <div key={index} className="mb-4 border-b pb-2">
                    <button
                        onClick={() => toggleFAQ(index)}
                        className="w-full text-left font-semibold text-lg flex justify-between"
                    >
                        {faq.question}
                        <span>{openIndex === index ? "−" : "+"}</span>
                    </button>
                    {openIndex === index && <p className="mt-2 text-gray-700">{faq.answer}</p>}
                </div>
            ))}
        </div>
    );
}

export default FAQs;
